const userName = "all-in-one-user"
export const getUserName = () => JSON.parse(localStorage.getItem(userName));
export const setUserName = (payload) => localStorage.setItem(userName, JSON.stringify(payload));